import {
  contractService,
  isContractInProgressAt,
  queryClientOptions
} from '@libs/data-access/queries'

const usePlannableContracts = (
  shiftDateISO: string,
  weeklyScheduleTeamId: number
) => {
  const { data, isLoading, status, error, isSuccess } =
    contractService.contract.useFetchAll(
      {
        queryParams: { team_ids: [weeklyScheduleTeamId] }
      },
      { staleTime: queryClientOptions.time.STATIC }
    )

  const inProgressPlannableContracts = (data ?? [])
    .filter(contract => contract.team_ids.includes(weeklyScheduleTeamId))
    .filter(contract => isContractInProgressAt(contract, shiftDateISO))

  return {
    data: inProgressPlannableContracts,
    isLoading,
    status,
    error,
    isSuccess
  }
}

export default usePlannableContracts
